<template>
  <div class="info" v-loading="loading">
    <div class="time">
      <div class="examinationInfo" v-if="examinationInfo != null">
        <div class="cell">
          <img src="../../assets/img/icon_5.png" />
          <div class="name">科目</div>
          <el-input
            v-model="examinationInfo.examinationCoursesName"
            placeholder=""
            readonly
          ></el-input>
        </div>
        <div class="cell">
          <img src="../../assets/img/icon_4.png" />
          <div class="name">考试时长</div>
          <el-input
            v-model="examinationInfo.examinationMinute"
            placeholder=""
            readonly
          ></el-input>
        </div>
        <div class="cell">
          <img src="../../assets/img/icon_4.png" />
          <div class="name">剩余时长</div>
          <el-input v-model="countdown" placeholder="" readonly></el-input>
        </div>

        <div class="btnBox1">
          <el-button
            type="primary"
            style="margin-left: 30px"
            :disabled="isSubmitDisabled"
            @click="submitFunc"
            :loading="submitLoading"
            >交卷</el-button
          >
        </div>
        <div class="btnBox">
          <el-button
            type="primary"
            style="margin-left: 30px"
            @click="changeLayout"
            >更改布局</el-button
          >
        </div>
      </div>
    </div>

    <div class="page" id="page">
      <div class="left" v-if="layout == true">
        <div style=" text-align: center">
          <img style="width: 70px; height: 98px" :src="avataricon" />
          <br />
          <div style="font-size: 18px; font-weight: bold">
            姓名:{{ userInfo.studentName }}
          </div>
          <div style="font-size: 18px; font-weight: bold">
            学号:{{ userInfo.studentNo }}
          </div>
        </div>
        <el-menu
          default-active="1"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          background-color="rgb(248,250,251)"
          text-color="#000"
          active-text-color="red"
          unique-opened
          collapse-transition
        >
          <el-submenu
            index="1"
            @click="switchItem('singx')"
            v-if="SingXList.length != undefined && SingXList.length > 0"
          >
            <template slot="title">
              <i class="el-icon-edit"></i>
              <span>单选题</span>
            </template>
            <el-menu-item-group v-if="subjectType === 'singx'" class="scroll">
              <el-menu-item
                style="background: #eee"
                v-for="(item, index) in SingXList"
                :key="index"
                :index="item.id.toString()"
                @click="singxIndexChange(index)"
                ><span
                  :x-id="item.serialnumber"
                  :class="{ color: singIndex[index] !== '' }"
                  >{{ index + 1 }}
                </span></el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>

          <el-submenu
            index="2"
            @click="switchItem('multx')"
            v-if="MultXList.length != undefined && MultXList.length > 0"
          >
            <template slot="title">
              <i class="el-icon-edit"></i>
              <span>多选题</span>
            </template>
            <el-menu-item-group v-if="subjectType === 'multx'" class="scroll">
              <el-menu-item
                style="background: #eee"
                v-for="(item, index) in MultXList"
                :key="index"
                :index="item.id.toString()"
                @click="multiIndexChange(index)"
                ><span
                  :class="{
                    color:
                      MultXList[index].answers.length !== 0 &&
                      MultXList[index].answers != undefined
                  }"
                  :x-id="item.serialnumber"
                  >{{ index + 1 }}
                </span></el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>

          <el-submenu
            index="3"
            @click="switchItem('judgex')"
            v-if="JudgXList.length > 0 && JudgXList.length != undefined"
          >
            <template slot="title">
              <i class="el-icon-edit"></i>
              <span>判断题</span>
            </template>
            <el-menu-item-group v-if="subjectType === 'judgex'" class="scroll">
              <el-menu-item
                style="background: #eee"
                v-for="(item, index) in JudgXList"
                :key="index"
                :index="item.id.toString()"
                @click="judgexChange(index)"
                ><span
                  :x-id="item.serialnumber"
                  :class="{ color: judgIndex[index] !== '' }"
                  >{{ index + 1 }}
                </span></el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>

          <el-submenu
            index="4"
            @click="switchItem('fillx')"
            v-if="FillXList.length > 0 && FillXList.length != undefined"
          >
            <template slot="title">
              <i class="el-icon-edit"></i>
              <span>填空题</span>
            </template>
            <el-menu-item-group v-if="subjectType === 'fillx'" class="scroll">
              <el-menu-item
                style="background: #eee"
                v-for="(item, index) in FillXList"
                :key="index"
                @click="fillxChange(index)"
                :index="item.id.toString()"
                ><span
                  :x-id="item.serialnumber"
                  :class="{ blue: FillXList[index].answers !== undefined }"
                  >{{ index + 1 }}
                </span></el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>

          <el-submenu
            index="5"
            @click="switchItem('proofx')"
            v-if="ProofXList.length > 0 && ProofXList.length != undefined"
          >
            <template slot="title">
              <i class="el-icon-edit"></i>
              <span>证明题</span>
            </template>
            <el-menu-item-group v-if="subjectType === 'proofx'" class="scroll">
              <el-menu-item
                style="background: #eee"
                v-for="(item, index) in ProofXList"
                :key="index"
                :index="item.id.toString()"
                @click="proofxChange(index)"
                ><span
                  :x-id="item.serialnumber"
                  :class="{ color: ProofXList[index].answers !== undefined }"
                  >{{ index + 1 }}
                </span></el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>

          <el-submenu
            index="6"
            @click="switchItem('anwsx')"
            v-if="AnwsXList.length > 0 && AnwsXList.length != undefined"
          >
            <template slot="title">
              <i class="el-icon-edit"></i>
              <span>计算题</span>
            </template>
            <el-menu-item-group v-if="subjectType === 'anwsx'" class="scroll">
              <el-menu-item
                style="background: #eee"
                v-for="(item, index) in AnwsXList"
                :key="index"
                :index="item.id.toString()"
                @click="anwsxChange(index)"
                ><span
                  :x-id="item.serialnumber"
                  :class="{ color: AnwsXList[index].answers !== undefined }"
                  >{{ index + 1 }}
                </span></el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </div>

      <div class="right" v-if="layout == false">
        <div class="item">
          <div class="title">
            <div>
              <div class="margin">单选题</div>
              <div
                v-for="(item, index) in SingXList1"
                :key="index"
                class="subTitle"
              >
                <div>
                  <span
                    v-for="(a, b) in item.steam"
                    :key="b"
                    :data-index="index"
                    style="word-wrap: break-word"
                  >
                    <div style="margin: 10px; overflow: scroll">
                      <span v-for="(i, j) in a.wordInfos" :key="j">
                        <span v-if="b === 0 && j === 0"> {{ index + 1 }}.</span>
                        <span v-if="i.wdType === 1" v-katex
                          >${{ i.latex }}$</span
                        >
                        <img v-else-if="i.wdType === 2" :src="i.buffer" />
                        <span v-else>{{ i.content }}</span>
                        <span
                          v-if="
                            b === item.steam.length - 1 &&
                              j === a.wordInfos.length - 1
                          "
                          >({{ item.score }}分)</span
                        >
                      </span>
                    </div>
                  </span>
                </div>
                <div class="groupbox wrap">
                  <el-radio-group
                    v-model="singIndex[index]"
                    class="el_radio_group"
                    @change="SingXListFnc1(index, singIndex[index])"
                  >
                    <div
                      v-for="(item, index) in SingXList1[index].options"
                      :key="index"
                    >
                      <el-radio
                        :label="orderList[index].label"
                        class="el_radio"
                      >
                        <span class="labelbox"
                          >{{ orderList[index].label }}.{{ str }}</span
                        >
                        <span v-for="(t, i) in item.ranginfos" :key="i">
                          <span v-for="(it, j) in t.wordInfos" :key="j">
                            <span v-if="it.wdType === 1" v-katex
                              >${{ it.latex }}$</span
                            >
                            <img v-else-if="it.wdType === 2" :src="it.buffer" />
                            <span v-else>{{ it.content }}</span>
                          </span>
                        </span>
                        <span>{{ item.score }}</span>
                      </el-radio>
                      <br />
                    </div>
                  </el-radio-group>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div
              class="margin"
              v-if="MultXList1.length != 0 && MultXList1.length != undefined"
            >
              多选题
            </div>
            <div
              v-for="(item, index) in MultXList"
              :key="index"
              class="subTitle"
              style="margin-bottom: 20px; overflow: scroll"
            >
              <div class="el_radio">
                <span v-for="(a, b) in item.steam" :key="b">
                  <span v-for="(i, j) in a.wordInfos" :key="j">
                    <span v-if="b === 0 && j === 0"> {{ index + 1 }}.</span>
                    <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                    <img v-else-if="i.wdType === 2" :src="i.buffer" />
                    <span v-else>{{ i.content }}</span>
                    <span
                      v-if="
                        b === item.steam.length - 1 &&
                          j === a.wordInfos.length - 1
                      "
                      >({{ item.score }}分)</span
                    >
                  </span>
                </span>
              </div>
              <div>
                <!-- 选项绑定临时数据multipleTemp暂不修改  -->
                <el-checkbox-group
                  v-model="multIndex[index]"
                  class="el_radio_group"
                  @change="MultXListChange1($event, index)"
                >
                  <div
                    class="multx wrap"
                    v-for="(item, index) in MultXList[index].options"
                    :key="index"
                  >
                    <el-checkbox
                      :label="orderList[index].label"
                      class="multx"
                      :key="index"
                    >
                      <span class="labelbox"
                        >{{ orderList[index].label }}.{{ str }}</span
                      >
                      <span v-for="(t, i) in item.ranginfos" :key="i">
                        <span v-for="(it, j) in t.wordInfos" :key="j">
                          <span v-if="it.wdType === 1" v-katex
                            >${{ it.latex }}$</span
                          >
                          <img v-else-if="it.wdType === 2" :src="it.buffer" />
                          <span v-else>{{ it.content }}</span>
                        </span>
                      </span>
                    </el-checkbox>
                  </div>
                </el-checkbox-group>
              </div>
            </div>
          </div>
          <div>
            <div
              class="margin"
              v-if="JudgXList1.length != 0 && JudgXList1.length != undefined"
            >
              判断题
            </div>
            <div
              v-for="(item, index) in JudgXList1"
              :key="index"
              class="subTitle"
              style="margin-bottom: 20px"
            >
              <div>
                <span
                  v-for="(a, b) in item.steam"
                  :key="b"
                  style="overflow: scroll"
                >
                  <span v-for="(i, j) in a.wordInfos" :key="j">
                    <span v-if="b === 0 && j === 0"> {{ index + 1 }}.</span>
                    <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                    <img v-else-if="i.wdType === 2" :src="i.buffer" />
                    <span v-else>{{ i.content }}</span>
                    <span
                      v-if="
                        b === item.steam.length - 1 &&
                          j === a.wordInfos.length - 1
                      "
                      >({{ item.score }}分)</span
                    >
                  </span>
                </span>
              </div>
              <el-radio-group
                v-model="judgIndex[index]"
                class="el_radio_group wrap"
                @change="JudgXListFnc1(index, judgIndex[index])"
              >
                <el-radio :label="1" class="el_radio wrap">
                  <span class="box"><i class="el-icon-circle-check"></i></span>
                </el-radio>
                <br />
                <el-radio :label="0" class="el_radio">
                  <span class="box"><i class="el-icon-circle-close"></i></span>
                </el-radio>
              </el-radio-group>
            </div>
          </div>

          <div class="title wrap">
            <div
              class="margin"
              v-if="FillXList1.length != 0 && FillXList1.length != undefined"
              style="margin-bottom: 20px"
            >
              填空题
            </div>

            <div
              v-for="(item, index) in FillXList1"
              :key="index"
              class="subTitle"
              style="margin-bottom: 30px"
            >
              <div>
                <span v-for="(a, b) in item.steam" :key="b">
                  <span v-for="(i, j) in a.wordInfos" :key="j">
                    <span v-if="b === 0 && j === 0"> {{ index + 1 }}.</span>
                    <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                    <img v-else-if="i.wdType === 2" :src="i.buffer" />
                    <span v-else>{{ i.content }}</span>
                    <span
                      v-if="
                        b === item.steam.length - 1 &&
                          j === a.wordInfos.length - 1
                      "
                      >({{ item.score }}分)</span
                    >
                  </span>
                </span>
              </div>
            </div>
          </div>

          <div
            class="title wrap"
            v-if="ProofXList1.length != 0 && ProofXList1.length != undefined"
          >
            <div class="margin" style="margin-bottom: 20px">证明题</div>

            <div
              v-for="(item, index) in ProofXList1"
              :key="index"
              class="subTitle"
              style="margin-bottom: 30px"
            >
              <div>
                <span v-for="(a, b) in item.steam" :key="b">
                  <span v-for="(i, j) in a.wordInfos" :key="j">
                    <span v-if="b === 0 && j === 0"> {{ index + 1 }}.</span>
                    <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                    <img v-else-if="i.wdType === 2" :src="i.buffer" />
                    <span v-else>{{ i.content }}</span>
                    <span
                      v-if="
                        b === item.steam.length - 1 &&
                          j === a.wordInfos.length - 1
                      "
                      >({{ item.score }}分)</span
                    >
                  </span>
                </span>
              </div>
            </div>
          </div>

          <div class="title wrap">
            <div
              class="margin"
              style="margin-bottom: 20px"
              v-if="AnwsXList1.length != 0 && AnwsXList1.length != undefined"
            >
              计算题
            </div>
            <div
              v-for="(item, index) in AnwsXList1"
              :key="index"
              class="subTitle"
              style="margin-bottom: 30px"
            >
              <div>
                <span
                  v-for="(a, b) in item.steam"
                  :key="b"
                  style="word-wrap: break-word"
                >
                  <span v-for="(i, j) in a.wordInfos" :key="j">
                    <span v-if="b === 0 && j === 0"> {{ index + 1 }}.</span>
                    <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                    <img v-else-if="i.wdType === 2" :src="i.buffer" />
                    <span v-else>{{ i.content }}</span>
                    <span
                      v-if="
                        b === item.steam.length - 1 &&
                          j === a.wordInfos.length - 1
                      "
                      >({{ item.score }}分)</span
                    >
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 数选项绑定的数据 v-model="singIndex[subjectIndex]"暂时不修改 -->

      <!-- 判断 -->
      <!-- <div class="title1 wrap" >
          <div>  三、判断题</div>
            <div
              v-for="(item, index) in JudgXList1"
              :key="index"
              class="margin"
            >
              <el-radio :label="orderList[index].label" class="el_radio wrap">
                {{ index + 1 }}.
                <span v-for="(a, b) in item.steam" :key="b">
                  <span v-for="(i, j) in a.wordInfos" :key="j">
                    <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                    <img v-else-if="i.wdType === 2" :src="i.buffer" />
                    <span v-else>{{ i.content }}</span>
                  </span>
                  <span class="box1">({{item.score}}分)</span>
                </span>
              </el-radio>
              <div class="groupbox wrap"> -->
      <!-- 数选项绑定的数据 v-model="singIndex[subjectIndex]"暂时不修改 -->
      <!-- <el-radio-group
                  v-model="judgIndex[index]"
                  class="el_radio_group wrap"
                  @change="JudgXListFnc(judgIndex[index])"
                >
                  <el-radio :label="1" class="el_radio wrap">
                    判断正确和错误选项改成了图标
                    <span class="box1"
                      ><i class="el-icon-circle-check"></i
                    ></span>
                  </el-radio>
                  <br />
                  <el-radio :label="0"  class="el_radio">
                    <span class="box1"
                      ><i class="el-icon-circle-close"></i
                    ></span>
                  </el-radio>
                </el-radio-group>
              </div>
            </div>
          </div> -->
      <!-- 填空 -->
      <!-- <div class="title wrap" >
            <span class="margin"> 四、填空题</span> 
            <div class="html" v-html="FillXList[subjectIndex].steam"></div> -->
      <!-- 题目信息 -->
      <!-- <div
              v-for="(item, index) in FillXList1"
              :key="index"
               class="title1"
            >
               {{index+1}}.
            <span v-for="(a, b) in item.steam" :key="b">
              <span v-for="(i, j) in a.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
              </span>
            </div>
          </div> -->
      <!-- 证明 -->
      <!-- <div class="title1 wrap">
             <span class="margin">五、证明题</span> -->
      <!-- <div class="html" v-html="ProofXList[subjectIndex].steam"></div>
             <div
              v-for="(item, index) in ProofXList1"
              :key="index"
               class="title"
            >
               {{index+1}}.
              <span v-for="(a, b) in item.steam" :key="b">
              <span v-for="(i, j) in a.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
              </span>
            </div>
          </div>  -->
      <!-- 计算 -->
      <!-- <div class="title1 wrap" >
             <div class="html" v-html="AnwsXList[subjectIndex].steam"></div>
            <span class="margin"> 六、计算题</span>
            <div
              v-for="(item, index) in AnwsXList1"
              :key="index"
              class="title"
            >
               {{index+1}}.
            <span v-for="(a, b) in item.steam" :key="b">
              <span v-for="(i, j) in a.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </span>
            </div>
          </div> 
        </div>
      </div> -->
      <!-- 右侧题目区域 -->
      <div class="right" v-if="layout == true">
        <div class="item">
          <div
            class="title"
            v-if="
              subjectType === 'singx' &&
                SingXList.length > 0 &&
                SingXList.length != undefined
            "
          >
            <div>
              <!-- 题目信息区域 -->
              <!-- <div class="html" v-html="SingXList[subjectIndex].steam"></div> -->
              <!-- 单选 -->
              <div
                v-for="(item, index) in SingXList1[subjectIndex].steam"
                :key="index"
                style="word-wrap: break-word"
              >
                <el-radio :label="orderList[index].label" class="el_radio">
                  <span v-for="(i, j) in item.wordInfos" :key="j">
                    <span v-if="index === 0 && j === 0">
                      {{ subjectIndex + 1 }}.</span
                    >
                    <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                    <img v-else-if="i.wdType === 2" :src="i.buffer" />
                    <span v-else>{{ i.content }}</span>
                    <span
                      v-if="
                        index === SingXList1[subjectIndex].steam.length - 1 &&
                          j === item.wordInfos.length - 1
                      "
                      >({{ SingXList1[subjectIndex].score }})分</span
                    >
                  </span>
                </el-radio>
              </div>
            </div>
          </div>
          <!-- 答案选择区域 -->
          <div
            class="groupbox wrap"
            v-if="
              subjectType === 'singx' &&
                SingXList.length > 0 &&
                SingXList.length != undefined
            "
          >
            <!-- 数选项绑定的数据 v-model="singIndex[subjectIndex]"暂时不修改-->
            <el-radio-group
              v-model="singIndex[subjectIndex]"
              class="el_radio_group"
              @change="SingXListFnc(singIndex[subjectIndex])"
            >
              <div
                v-for="(item, index) in SingXList1[subjectIndex].options"
                :key="index"
              >
                <el-radio :label="orderList[index].label" class="el_radio">
                  <span class="labelbox"
                    >{{ orderList[index].label }}.{{ str }}</span
                  >
                  <span v-for="(t, i) in item.ranginfos" :key="i">
                    <span v-for="(it, j) in t.wordInfos" :key="j">
                      <span v-if="it.wdType === 1" v-katex
                        >${{ it.latex }}$</span
                      >
                      <img v-else-if="it.wdType === 2" :src="it.buffer" />
                      <span v-else>{{ it.content }}</span>
                    </span>
                  </span>
                </el-radio>
                <br />
              </div>
            </el-radio-group>
          </div>
          <!-- 多选 -->
          <div class="title" v-if="subjectType === 'multx'">
            <!-- <div class="html" v-html="MultXList[subjectIndex].steam"></div> -->
            <!-- 题目信息 -->
            <div>
              <div
                v-for="(item, index) in MultXList1[subjectIndex].steam"
                :key="index"
                style="word-wrap: break-word"
              >
                <span v-for="(i, j) in item.wordInfos" :key="j">
                  <span v-if="index === 0 && j === 0">
                    {{ subjectIndex + 1 }}.</span
                  >
                  <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                  <img v-else-if="i.wdType === 2" :src="i.buffer" />
                  <span v-else>{{ i.content }}</span>
                  <span
                    v-if="
                      index === MultXList1[subjectIndex].steam.length - 1 &&
                        j === item.wordInfos.length - 1
                    "
                    >({{ MultXList1[subjectIndex].score }})分</span
                  >
                </span>
              </div>
            </div>
          </div>
          <div v-if="subjectType === 'multx'">
            <!-- 选项绑定临时数据multipleTemp暂不修改  -->
            <el-checkbox-group
              v-model="multipleTemp"
              class="el_radio_group"
              @change="MultXListChange($event, subjectIndex)"
            >
              <div
                class="multx wrap"
                v-for="(item, index) in MultXList1[subjectIndex].options"
                :key="index"
              >
                <el-checkbox
                  :label="orderList[index].label"
                  class="multx"
                  :key="index"
                >
                  <span class="labelbox"
                    >{{ orderList[index].label }}.{{ str }}</span
                  >
                  <span v-for="(t, i) in item.ranginfos" :key="i">
                    <span v-for="(it, j) in t.wordInfos" :key="j">
                      <span v-if="it.wdType === 1" v-katex
                        >${{ it.latex }}$</span
                      >
                      <img v-else-if="it.wdType === 2" :src="it.buffer" />
                      <span v-else>{{ it.content }}</span>
                    </span>
                  </span>
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
          <!-- 判断 -->
          <div class="title" v-if="subjectType === 'judgex'">
            <!-- <div class="html" v-html="JudgXList[subjectIndex].steam"></div> -->
            <div>
              <div
                v-for="(item, index) in JudgXList1[subjectIndex].steam"
                :key="index"
                style="word-wrap: break-word"
              >
                <span v-for="(i, j) in item.wordInfos" :key="j">
                  <span v-if="index === 0 && j === 0">
                    {{ subjectIndex + 1 }}.</span
                  >
                  <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                  <img v-else-if="i.wdType === 2" :src="i.buffer" />
                  <span v-else>{{ i.content }}</span>
                  <span
                    v-if="
                      index === JudgXList1[subjectIndex].steam.length - 1 &&
                        j === item.wordInfos.length - 1
                    "
                    >({{ JudgXList1[subjectIndex].score }})分</span
                  >
                </span>
              </div>
            </div>
          </div>
          <div v-if="subjectType === 'judgex'">
            <!-- 绑定数据暂不修改 -->
            <el-radio-group
              v-model="judgIndex[subjectIndex]"
              class="el_radio_group wrap"
              @change="JudgXListFnc(judgIndex[subjectIndex])"
            >
              <el-radio :label="1" class="el_radio wrap">
                <!-- 判断正确和错误选项改成了图标 -->
                <span class="box"><i class="el-icon-circle-check"></i></span>
              </el-radio>
              <br />
              <el-radio :label="0" class="el_radio">
                <span class="box"><i class="el-icon-circle-close"></i></span>
              </el-radio>
            </el-radio-group>
          </div>
          <!-- 填空 -->
          <div class="title" v-if="subjectType === 'fillx'">
            <!-- <div class="html" v-html="FillXList[subjectIndex].steam"></div> -->
            <!-- 题目信息 -->
            <div>
              <div
                v-for="(item, index) in FillXList1[subjectIndex].steam"
                :key="index"
                style="word-wrap: break-word"
              >
                <span v-for="(i, j) in item.wordInfos" :key="j">
                  <span v-if="index === 0 && j === 0">
                    {{ subjectIndex + 1 }}.</span
                  >
                  <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                  <img v-else-if="i.wdType === 2" :src="i.buffer" />
                  <span v-else>{{ i.content }}</span>
                  <span
                    v-if="
                      index === FillXList1[subjectIndex].steam.length - 1 &&
                        j === item.wordInfos.length - 1
                    "
                    >({{ FillXList1[subjectIndex].score }})分</span
                  >
                </span>
              </div>
            </div>
          </div>
          <!-- 证明 -->
          <div class="title" v-if="subjectType === 'proofx'">
            <!-- <div class="html" v-html="ProofXList[subjectIndex].steam"></div> -->
            <div>
              <div
                v-for="(item, index) in ProofXList1[subjectIndex].steam"
                :key="index"
                style="word-wrap: break-word"
              >
                <span v-for="(i, j) in item.wordInfos" :key="j">
                  <span v-if="index === 0 && j === 0">
                    {{ subjectIndex + 1 }}.</span
                  >
                  <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                  <img v-else-if="i.wdType === 2" :src="i.buffer" />
                  <span v-else>{{ i.content }}</span>
                  <span
                    v-if="
                      index === ProofXList1[subjectIndex].steam.length - 1 &&
                        j === item.wordInfos.length - 1
                    "
                    >({{ ProofXList1[subjectIndex].score }})分</span
                  >
                </span>
              </div>
            </div>
          </div>
          <!-- 计算 -->

          <div class="title wrap" v-if="subjectType === 'anwsx'">
            <!-- <div class="html" v-html="AnwsXList[subjectIndex].steam"></div> -->
            <div>
              <div
                v-for="(item, index) in AnwsXList1[subjectIndex].steam"
                :key="index"
              >
                <span v-for="(i, j) in item.wordInfos" :key="j">
                  <span v-if="index === 0 && j === 0">
                    {{ subjectIndex + 1 }}.</span
                  >
                  <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                  <img v-else-if="i.wdType === 2" :src="i.buffer" />
                  <span v-else>{{ i.content }}</span>
                  <span
                    v-if="
                      index === AnwsXList1[subjectIndex].steam.length - 1 &&
                        j === item.wordInfos.length - 1
                    "
                    >({{ AnwsXList1[subjectIndex].score }})分</span
                  >
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- 底部题目切换区域 -->
        <div class="bottom">
          <el-button class="last" @click="last" type="primary"
            >上一题</el-button
          >
          <div>|</div>
          <el-button class="next" @click="next" type="primary"
            >下一题</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getExaminationID,
  subAnswer,
  uploadAnswer,
  getStudentExaminationList,
  pushStudentType,
  getTimes
  // getExaminationID,
  // getExaminationInfoById
} from "@/api/student";
//import Steam from "@/util/steam.js";
import { convertToFullQuestion } from "@/util/extraction.js";
import _ from "lodash";
import { mapState, mapGetters } from "vuex";

// import { getInfo, setInfo } from "@/util/session";
export default {
  name: "detail",
  data() {
    return {
      unfinished: [],
      isSubmitDisabled: false,
      loading: false,
      studentNo: "",
      localIp: "",
      isActive1: false,
      active: 0,
      isActive: "",
      str: "\u3000",
      list: [],
      radio: 3,
      SingXList: [],
      MultXList: [],
      JudgXList: [],
      ProofXList: [],
      FillXList: [],
      AnwsXList: [],
      //只用作渲染的数据
      SingXList1: [],
      MultXList1: [],
      JudgXList1: [],
      ProofXList1: [],
      FillXList1: [],
      AnwsXList1: [],
      //
      loding: false,
      subjectType: "singx",
      subjectIndex: 0,

      //
      multIndex: [],
      singIndex: [],
      judgIndex: [],
      //
      orderList: [
        {
          value: 0,
          label: "A"
        },
        {
          value: 1,
          label: "B"
        },
        {
          value: 2,
          label: "C"
        },
        {
          value: 3,
          label: "D"
        },
        {
          value: 4,
          label: "E"
        },
        {
          value: 5,
          label: "F"
        },
        {
          value: 6,
          label: "G"
        },
        {
          value: 7,
          label: "H"
        },
        {
          value: 8,
          label: "I"
        }
      ],
      avataricon: "",
      userInfo: {},
      layout: true,
      contentHeight: 0,
      submitLoading: false,
      isSubmitting: false,
      pendingUploads: [],
      uploadTimers: {},
      examinationDiff: "",
      examinationSer: "",
      multipleTemp: [],
      // multiAns: [],
      examinationList: [],
      systemDate: "",
      startTime: "",
      studentInfo: {},
      index: 0,
      subjectList: {},
      paperID: "",
      numberOf: 0,
      allNumof: 0
    };
  },
  created() {
    localStorage.setItem("numof", this.allNumof);
  },
  mounted() {
    this.avataricon = sessionStorage.getItem("avataricon");
    let userInfo = localStorage.getItem("userInfo");
    this.userInfo = JSON.parse(userInfo);
    //console.log(this.userInfo, this.avataricon);
    document.addEventListener("visibilitychange", this.handleVisibilitychange);
    window.addEventListener("blur", this.handleBlur);
    window.onbeforeunload = function() {
      return "quit?";
    };
    this.examinationDiff = this.$route.query.examinationDiff;
    this.examinationSer = this.$route.query.examinationSer;
    this.studentType = this.$route.query.studenttype;
    this.getDetail();
    this.contentHeight = document.body.clientHeight - 64;
    this.paperID = localStorage.getItem("paperID");
    this.studentNo = JSON.parse(localStorage.getItem("userInfo"));
  },
  //清除定时器
  destroyed() {
    localStorage.setItem("numof", this.allNumof);
    clearInterval(this.interval);
    this.clearUploadTimers();
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilitychange
    );
    this.exitFullscreen();
    window.removeEventListener("blur", this.handleBlur);
  },

  computed: {
    ...mapState({
      examinationInfo: state => state.examination.examinationInfo,
      countdownTime: state => state.examination.countdownTime
    }),
    ...mapGetters(["countdown", "enableSubmit"])
  },

  watch: {},
  methods: {
    exitFullscreen() {
      if (document.exitFullScreen) {
        document.exitFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
    screenfullEnter() {
      const el = document.documentElement;
      const eventEnter =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullScreen;
      if (typeof eventEnter !== "undefined" && eventEnter) {
        eventEnter.call(el);
        // this.isFullscreen = true
      }
    },
    clearUploadTimers() {
      Object.keys(this.uploadTimers).forEach(key => {
        const timerInfo = this.uploadTimers[key];
        clearTimeout(timerInfo.timer);
        if (timerInfo.resolve) {
          timerInfo.resolve(null);
        }
      });
      this.uploadTimers = {};
    },
    trackUpload(promise) {
      this.pendingUploads.push(promise);
      const removeUpload = () => {
        this.pendingUploads = this.pendingUploads.filter(item => item !== promise);
      };
      promise.then(removeUpload, removeUpload);
      return promise;
    },
    uploadAnswerSafely(payload, options = {}) {
      if (this.isSubmitting || this.submitLoading) {
        return Promise.resolve(null);
      }
      const delay = 0; // Changed from 800ms debounce to submit immediately
      const doUpload = () => {
        const promise = uploadAnswer(payload)
          .then(res => {
            if (
              res.code !== 200 &&
              !this.isSubmitting &&
              !this.submitLoading
            ) {
              this.$message.error(res.message || "答案保存失败，请稍后重试");
            }
            return res;
          })
          .catch(error => {
            if (!this.isSubmitting && !this.submitLoading) {
              this.$message.error(
                error && error.message
                  ? error.message
                  : "答案保存失败，请稍后重试"
              );
            }
            return null;
          });
        return this.trackUpload(promise);
      };
      if (delay === 0) {
        return doUpload();
      }
      if (this.uploadTimers[key]) {
        clearTimeout(this.uploadTimers[key].timer);
        if (this.uploadTimers[key].resolve) {
          this.uploadTimers[key].resolve(null);
        }
      }
      return new Promise(resolve => {
        this.uploadTimers[key] = {
          timer: setTimeout(() => {
            delete this.uploadTimers[key];
            doUpload().then(resolve);
          }, delay),
          resolve
        };
      });
    },
    async waitPendingUploads() {
      this.clearUploadTimers();
      const uploads = this.pendingUploads.slice();
      if (uploads.length > 0) {
        await Promise.all(uploads.map(item => item.catch(() => null)));
      }
    },
    handleVisibilitychange() {
      if (this.isSubmitting || this.submitLoading) {
        return;
      }
      let visibilityState = document.visibilityState;

      if (visibilityState === "hidden") {
        let params = {
          message: "学生切换浏览器窗口，离开考试页面",
          operateName: "离开页面",
          operateType: 2,
          paperID: this.paperID,
          userID: this.studentNo.studentId
        };
        pushStudentType(params).then(res => {
          console.log(res, "成功");
        });
        this.$alert(
          "检测到您离开了考试页面，该行为已记录。请立即返回并继续考试！",
          "考场警告",
          {
            confirmButtonText: "我知道了",
            type: "warning"
          }
        );
      }

      this.numberOf = localStorage.getItem("numof");
    },

    handleBlur() {
      if (this.isSubmitting || this.submitLoading) {
        return;
      }
      this.screenfullEnter();
      this.allNumof++;
      console.log(this.studentType);
      let params = {
        message: "学生鼠标点击焦点不在考试页面，考试过程已记录",
        operateName: "离开页面",
        operateType: 2,
        paperID: this.paperID,
        userID: this.studentNo.studentId
      };
      pushStudentType(params).then(res => {
        console.log(res, "成功");
      });

      localStorage.setItem("numof", this.allNumof);

      this.$message.error("请不要点击考试页面以外的区域，离开记录已增加。");
    },
    changeLayout() {
      this.loading = true;
      setTimeout(() => {
        this.layout = !this.layout;
        this.MultXList.forEach((item, index) => {
          this.multIndex[index] = item.answers;
        });

        this.$forceUpdate();
        this.loading = false;
      }, 1000);
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
      let selecttag = key[0];
      if (selecttag === "1") {
        this.switchItem("singx");
      } else if (selecttag === "2") {
        this.switchItem("multx");
      } else if (selecttag === "3") {
        this.switchItem("judgex");
      } else if (selecttag === "4") {
        this.switchItem("fillx");
      } else if (selecttag === "5") {
        this.switchItem("proofx");
      } else if (selecttag === "6") {
        this.switchItem("anwsx");
      }
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },

    singxIndexChange(index) {
      this.subjectIndex = index;
      let arr = this.SingXList1[this.subjectIndex].options;
      //先置空,然后再渲染,解决选项显示不刷新的问题
      this.SingXList1[this.subjectIndex].options = [];
      let arrq = this.SingXList1[this.subjectIndex].steam;
      this.SingXList1[this.subjectIndex].steam = [];
      // this.randomSortArray(arr);
      this.$nextTick(() => {
        this.SingXList1[this.subjectIndex].options = arr;
        this.SingXList1[this.subjectIndex].steam = arrq;
      });
    },
    judgexChange(index) {
      this.subjectIndex = index;
      let arr = this.JudgXList1[this.subjectIndex].steam;
      this.JudgXList1[this.subjectIndex].steam = [];
      this.$nextTick(() => {
        this.JudgXList1[this.subjectIndex].steam = arr;
      });
    },
    fillxChange(index) {
      this.subjectIndex = index;
      let arr = this.FillXList1[this.subjectIndex].steam;
      this.FillXList1[this.subjectIndex].steam = [];
      this.$nextTick(() => {
        this.FillXList1[this.subjectIndex].steam = arr;
      });
    },
    proofxChange(index) {
      this.subjectIndex = index;
      let arr = this.ProofXList1[this.subjectIndex].steam;
      this.ProofXList1[this.subjectIndex].steam = [];
      this.$nextTick(() => {
        this.ProofXList1[this.subjectIndex].steam = arr;
      });
    },
    anwsxChange(index) {
      this.subjectIndex = index;
      let arr = this.AnwsXList1[this.subjectIndex].steam;
      this.AnwsXList1[this.subjectIndex].steam = [];
      this.$nextTick(() => {
        this.AnwsXList1[this.subjectIndex].steam = arr;
      });
    },
    fnc() {
      getStudentExaminationList().then(res => {
        this.examinationList = res.data.examinationinfoResps;
        this.systemDate = res.data.systemDate;
        this.examinationList = this.examinationList.filter(item => {
          return item.id == this.$route.query.id;
        });
      });
    },
    //加载考试信息
    async getDetail() {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let params = {
        paperId: this.$route.query.paperId,
        localIp: this.$route.query.localIp
      };
      try {
        let resctm = await getTimes();
        const strdata = resctm.data.data;
        const currentDate = new Date(strdata).getTime();
        let res = await getExaminationID(params);
        //考试开始时间
        let strstarttime = res.data.startTime;
        this.startTime = new Date(strstarttime).getTime();
        const exammt = this.$route.query.examinationMinute;
        const endtime = new Date(this.startTime + exammt * 60 * 1000);
        // 计算当前剩余分钟数（仅用于初始化 state，精确倒计时由 store 内部 currenttm 决定）
        const remainMinutes =
          exammt - (currentDate - this.startTime) / (60 * 1000);

        this.$store.commit("setExaminationInfo", {
          examinationCoursesName: this.$route.query.examinationCoursesName,
          examinationMinute: this.$route.query.examinationMinute, // 考试时长（分钟）
          examinationMinutes: remainMinutes, // 剩余（分钟）
          endtime: endtime.getTime(),
          startTime: this.startTime // 进入考试时间
        });
        //调用vuex里面的方法,倒计时
        this.interval = setInterval(() => {
          this.$store.commit("countdownTimeMinus");
          this.checkoutSubmit();
        }, 1000);
        //只用做渲染 start
        let arrs = res.data.list.map(item => {
          return convertToFullQuestion(item); //解析时,是旧的数据没有js的,就传第二个参数为1,调用另一个方法
        });
        this.JudgXList1 = arrs.filter(item => {
          return item.subjectType === "JudgX";
        });
        this.FillXList1 = arrs.filter(item => {
          return item.subjectType === "FillX";
        });
        this.ProofXList1 = arrs.filter(item => {
          return item.subjectType === "ProofX";
        });
        this.AnwsXList1 = arrs.filter(item => {
          return item.subjectType === "AnwsX";
        });
        this.SingXList1 = arrs.filter(item => {
          return item.subjectType === "SingX";
        });
        this.MultXList1 = arrs.filter(item => {
          return item.subjectType === "MultX";
        });
        //添加选项文本标签，用户答案0123，转abcd
        this.SingXList = this.SingXList1.map(item => {
          item.answerIndex = item.order.split(",").map((x, index) => {
            let l = {};
            l.value = x;
            l.name = "ABCDEFGHIJKLMN".substr(index, 1);
            return l;
          });

          let fditem = item.answerIndex.find(answeritem => {
            return answeritem.value == item.usr_choice;
          });
          if (fditem == undefined) {
            item.usr_choice = "";
          } else {
            item.usr_choice = fditem.name;
          }
          item.answers = item.usr_choice;
          return item;
        });
        //单选历史选择结果放到singxlist
        this.SingXList.forEach(item => {
          if (item.answers) {
            this.singIndex.push(item.answers);
          } else {
            this.singIndex.push("");
          }
        });

        //多选题标签，多选user_choice转abc，注意答案是array
        this.MultXList = this.MultXList1.map(item => {
          let item1 = { ...item };
          item1.answerIndex = item1.order.split(",").map((x, index) => {
            let l = {};
            l.value = x;
            l.name = "ABCDEFGHIJKLMN".substr(index, 1);
            return l;
          });
          let answs = [];
          let usrchs = item.usr_choice.split(",");
          usrchs.forEach(usr_ch => {
            let tempAnswer = item1.answerIndex.find(answeritem => {
              return answeritem.value == usr_ch;
            });
            if (typeof tempAnswer !== "undefined") {
              answs.push(tempAnswer.name);
            }
          });
          console.log(usrchs);

          item1.answers = answs;
          console.log(item1);
          return item1;
        });
        console.log(this.MultXList);
        this.JudgXList = this.JudgXList1.map(item => {
          let item1 = { ...item };
          return item1;
        });
        this.JudgXList.forEach(item => {
          item.usr_choice = item.usr_choice.toString();

          item.order = 0;
          if (item.usr_choice === "1") {
            item.answers = 1;
          } else if (item.usr_choice === "0") {
            item.answers = 0;
          } else {
            item.answers = "";
          }
          return item;
        });

        this.JudgXList.forEach(item => {
          this.judgIndex.push(item.answers);
        });
        this.ProofXList = this.ProofXList1.filter(item => {
          return item.subjectType === "ProofX";
        });

        this.FillXList = this.FillXList1.filter(item => {
          return item.subjectType === "FillX";
        });

        this.AnwsXList = this.AnwsXList1.filter(item => {
          return item.subjectType === "AnwsX";
        });
        this.$nextTick(() => {
          this.setImageWidth();
        });
        loading.close();
      } catch (err) {
        console.log(err);
        loading.close();
      }
    },
    setImageWidth() {
      let subjectImg = [];

      let imgs = document.getElementsByTagName("img");

      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i].className == "subjectImage") {
          subjectImg.push(imgs[i]);
        }
      }
      subjectImg.forEach(item => {
        item.style.zoom = "50%";
      });
    },
    switchItem(type) {
      this.active = 1;
      this.isActive = type;
      this.subjectType = type;

      this.subjectIndex = 0;
      if (type === "singx") {
        let arr = this.SingXList1[this.subjectIndex].options;
        this.SingXList1[this.subjectIndex].options = [];
        let arrq = this.SingXList1[this.subjectIndex].steam;
        this.SingXList1[this.subjectIndex].steam = [];
        // this.randomSortArray(arr);
        this.$nextTick(() => {
          this.SingXList1[this.subjectIndex].options = arr;
          this.SingXList1[this.subjectIndex].steam = arrq;
        });
      }
      if (type === "multx") {
        console.log(this.subjectType);
        let arr = this.MultXList1[this.subjectIndex].options;
        this.MultXList1[this.subjectIndex].options = [];
        let arrq = this.MultXList1[this.subjectIndex].steam;
        this.MultXList1[this.subjectIndex].steam = [];
        // this.randomSortArray(arr);
        this.$nextTick(() => {
          this.MultXList1[this.subjectIndex].options = arr;
          this.MultXList1[this.subjectIndex].steam = arrq;
        });
      }
      if (type === "judgex") {
        let arr = this.JudgXList1[this.subjectIndex].steam;
        this.JudgXList1[this.subjectIndex].steam = [];
        this.$nextTick(() => {
          this.JudgXList1[this.subjectIndex].steam = arr;
        });
      }
      if (type === "fillx") {
        let arr = this.FillXList1[this.subjectIndex].steam;
        this.FillXList1[this.subjectIndex].steam = [];

        this.$nextTick(() => {
          this.FillXList1[this.subjectIndex].steam = arr;
        });
      }
      if (type === "proofx") {
        let arr = this.ProofXList1[this.subjectIndex].steam;
        this.ProofXList1[this.subjectIndex].steam = [];
        this.$nextTick(() => {
          this.ProofXList1[this.subjectIndex].steam = arr;
        });
      }
      if (type === "anwsx") {
        let arr = this.AnwsXList1[this.subjectIndex].steam;
        this.AnwsXList1[this.subjectIndex].steam = [];
        this.$nextTick(() => {
          this.AnwsXList1[this.subjectIndex].steam = arr;
        });
      }
      if (this.subjectType === "multx") {
        this.multipleTemp = this.MultXList[this.subjectIndex].answers;
      }
    },
    //选择答案时的处理
    SingXListFnc(val) {
      //console.log("id", this.SingXList[this.subjectIndex].id);
      this.SingXList[this.subjectIndex].answers = val;

      let indexs = "";
      let tempAnswer = this.SingXList[this.subjectIndex].answerIndex.find(
        item => item.name == val
      );

      indexs = tempAnswer.value;
      const list = {
        answer: indexs,
        correctOrder: this.SingXList[this.subjectIndex].correctOrder,
        examinationDiff: this.$route.query.examinationDiff,
        examinationSer: this.$route.query.examinationSer,
        id: this.SingXList[this.subjectIndex].id,
        knowledgeID: this.SingXList[this.subjectIndex].knowledgeID,
        order: this.SingXList[this.subjectIndex].order,
        qid: this.SingXList[this.subjectIndex].qID,
        qtype: this.SingXList[this.subjectIndex].qtype,
        score: this.SingXList[this.subjectIndex].score
        // usr_choice: index
      };

      //console.log("upload-answer",list)
      this.uploadAnswerSafely([list]);
    },
    SingXListFnc1(index, val) {
      //console.log("id", this.SingXList[this.subjectIndex].id);

      this.SingXList[index].answers = val;

      let single = "";
      let tempAnswer = this.SingXList[index].answerIndex.find(
        item => item.name == val
      );

      single = tempAnswer.value;

      const list = {
        answer: single,
        correctOrder: this.SingXList[index].correctOrder,
        examinationDiff: this.$route.query.examinationDiff,
        examinationSer: this.$route.query.examinationSer,
        id: this.SingXList[index].id,
        knowledgeID: this.SingXList[index].knowledgeID,
        order: this.SingXList[index].order,
        qid: this.SingXList[index].qID,
        qtype: this.SingXList[index].qtype,
        score: this.SingXList[index].score
        // usr_choice: index
      };
      this.uploadAnswerSafely([list]);
    },
    JudgXListFnc(val) {
      this.JudgXList[this.subjectIndex].answers = val;
      const list = {
        answer: val,
        correctOrder: this.JudgXList[this.subjectIndex].judge,
        examinationDiff: this.$route.query.examinationDiff,
        examinationSer: this.$route.query.examinationSer,
        id: this.JudgXList[this.subjectIndex].id,
        knowledgeID: this.JudgXList[this.subjectIndex].knowledgeID,
        order: this.JudgXList[this.subjectIndex].order,
        qid: this.JudgXList[this.subjectIndex].qID,
        qtype: this.JudgXList[this.subjectIndex].qtype,
        score: this.JudgXList[this.subjectIndex].score
      };
      //console.log("upload-judex", list);
      this.uploadAnswerSafely([list]);
    },
    JudgXListFnc1(index, val) {
      this.JudgXList[index].answers = val;
      const list = {
        answer: val,
        correctOrder: this.JudgXList[index].judge,
        examinationDiff: this.$route.query.examinationDiff,
        examinationSer: this.$route.query.examinationSer,
        id: this.JudgXList[index].id,
        knowledgeID: this.JudgXList[index].knowledgeID,
        order: this.JudgXList[index].order,
        qid: this.JudgXList[index].qID,
        qtype: this.JudgXList[index].qtype,
        score: this.JudgXList[index].score
      };
      //console.log("upload-judex", list);
      this.uploadAnswerSafely([list]);
    },
    last() {
      if (this.subjectIndex === 0) {
        return;
      }

      this.subjectIndex = this.subjectIndex - 1;
      if (this.subjectType === "singx") {
        this.singxIndexChange(this.subjectIndex);
      }
      if (this.subjectType === "judgex") {
        this.judgexChange(this.subjectIndex);
      }
      if (this.subjectType === "fillx") {
        this.fillxChange(this.subjectIndex);
      }
      if (this.subjectType === "proofx") {
        this.proofxChange(this.subjectIndex);
      }
      if (this.subjectType === "anwsx") {
        this.anwsxChange(this.subjectIndex);
      }
      if (this.subjectType === "multx") {
        this.multiIndexChange(this.subjectIndex);
        this.multipleTemp = this.MultXList[this.subjectIndex].answers;
      }
    },
    next() {
      if (
        this.subjectType === "singx" &&
        this.subjectIndex < this.SingXList.length - 1
      ) {
        this.subjectIndex = this.subjectIndex + 1;
        this.singxIndexChange(this.subjectIndex);

        if (this.subjectIndex == this.SingXList.length - 1) {
          this.$message("该题型到底了");
        }
      } else if (
        this.subjectType === "multx" &&
        this.subjectIndex < this.MultXList.length - 1
      ) {
        this.subjectIndex = this.subjectIndex + 1;
        this.multiIndexChange(this.subjectIndex);
        if (this.subjectIndex == this.MultXList.length - 1) {
          this.$message("该题型到底了");
        }
      } else if (
        this.subjectType === "judgex" &&
        this.subjectIndex < this.JudgXList.length - 1
      ) {
        this.subjectIndex = this.subjectIndex + 1;
        this.judgexChange(this.subjectIndex);
        if (this.subjectIndex == this.JudgXList.length - 1) {
          this.$message("该题型到底了");
        }
      } else if (
        this.subjectType === "fillx" &&
        this.subjectIndex < this.FillXList.length - 1
      ) {
        this.subjectIndex = this.subjectIndex + 1;
        this.fillxChange(this.subjectIndex);
        if (this.subjectIndex == this.FillXList.length - 1) {
          this.$message("该题型到底了");
        }
      } else if (
        this.subjectType === "proofx" &&
        this.subjectIndex < this.ProofXList.length - 1
      ) {
        this.subjectIndex = this.subjectIndex + 1;
        this.proofxChange(this.subjectIndex);
        if (this.subjectIndex == this.ProofXList.length - 1) {
          this.$message("该题型到底了");
        }
      } else if (
        this.subjectType === "anwsx" &&
        this.subjectIndex < this.AnwsXList.length - 1
      ) {
        this.subjectIndex = this.subjectIndex + 1;
        this.anwsxChange(this.subjectIndex);
        if (this.subjectIndex == this.AnwsXList.length - 1) {
          this.$message("该题型到底了");
        }
      }
      if (this.subjectType === "multx") {
        this.multipleTemp = this.MultXList[this.subjectIndex].answers;
      }
    },
    async submit() {
      if (this.isSubmitting || this.submitLoading) {
        return;
      }
      let params = [];

      params = _.cloneDeep(
        params.concat(
          this.SingXList,
          this.MultXList,
          this.JudgXList,
          this.FillXList,
          this.ProofXList,
          this.AnwsXList
        )
      ).map(item => {
        let nitem = {
          answer: item.answer,
          correctOrder: item.correctOrder,
          examinationDiff: "",
          examinationSer: this.examinationSer,
          id: item.id,
          knowledgeID: item.knowledgeID,
          order: item.order,
          qid: item.qid,
          qtype: item.subjectType,
          score: item.score
        };
        return nitem;
      });
      this.isSubmitting = true;
      this.submitLoading = true;
      this.isSubmitDisabled = true;
      this.loading = true;
      let keepSubmitLocked = false;
      try {
        await this.waitPendingUploads();
        const res = await subAnswer(params);
        console.log(res);
        // if(res.data.code !== 200) {
        //   this.$message.error(res.data.message);
        //   //return
        // }
        if (res.code === 200) {
          keepSubmitLocked = true;
          this.$message.success("交卷成功");
          const subscore = "客观题" + res.data + "分";
          let param = {
            message: "学生交卷，",
            operateName: "交卷",
            operateType: 3,
            paperID: this.paperID,
            userID: this.studentNo.studentId
          };
          pushStudentType(param).then(res => {
            console.log(res, "成功");
          });
          window.onbeforeunload = null;

          // this.$store.commit("reload", true);
          this.loading = false;
          await this.$alert(subscore, "提示", {
            confirmButtonText: "确认",
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false
          });
          this.$router.push("/login");
        } else if (res.code === 15002) {
          keepSubmitLocked = true;
          window.onbeforeunload = null;
          this.$message.warning("已交卷，转入登录");
          this.$router.push("/login");
        } else if (res.code === 15001) {
          this.$message.warning("当前考试不存在");
        } else {
          this.loading = false;
          this.$message.warning(res.message || "交卷失败");
        }
      } catch (error) {
        if (!keepSubmitLocked) {
          this.$message.error(
            error && error.message ? error.message : "交卷失败，请检查网络后重试"
          );
        }
      } finally {
        this.loading = false;
        if (!keepSubmitLocked) {
          this.submitLoading = false;
          this.isSubmitDisabled = false;
          this.isSubmitting = false;
        }
      }
    },
    //多选题答案处理
    MultXListChange(value, index) {
      //把每一题的答案都加入的MultXList里面
      console.log(value);
      this.$set(this.MultXList[index], "answers", value);
      //console.log("this.MultXList[index]", this.MultXList[index]);
      var list = "";
      value.forEach(valueitem => {
        let tempAnswer = this.MultXList[index].answerIndex.find(
          item => item.name == valueitem
        );
        list += `${tempAnswer.value},`;
      });
      //选项所对应的索引
      //console.log("list", list);
      console.log(list);
      if (list.length > 0) {
        list = list.substr(0, list.length - 1);
      }
      var str = {
        answer: list,
        correctOrder: this.MultXList[this.subjectIndex].correctOrder,
        examinationDiff: this.$route.query.examinationDiff,
        examinationSer: this.$route.query.examinationSer,
        id: this.MultXList[this.subjectIndex].id,
        knowledgeID: this.MultXList[this.subjectIndex].knowledgeID,
        order: this.MultXList[this.subjectIndex].order,
        qid: this.MultXList[this.subjectIndex].qID,
        qtype: this.MultXList[this.subjectIndex].qtype,
        score: this.MultXList[this.subjectIndex].score
      };
      // console.log("str", str);
      this.uploadAnswerSafely([str]);
    },
    MultXListChange1(value, index) {
      console.log(value, index);
      //把每一题的答案都加入的MultXList里面
      this.$set(this.MultXList[index], "answers", value);
      console.log(this.MultXList[index]);
      var list = "";
      value.forEach(valueitem => {
        let tempAnswer = this.MultXList[index].answerIndex.find(
          item => item.name == valueitem
        );
        list += `${tempAnswer.value},`;
      });
      //选项所对应的索引
      //console.log("list", list);
      // if (list.length > 0) {
      //   list = list.substr(0, list.length - 1);
      // }
      var str = {
        answer: list,
        correctOrder: this.MultXList[index].correctOrder,
        examinationDiff: this.$route.query.examinationDiff,
        examinationSer: this.$route.query.examinationSer,
        id: this.MultXList[index].id,
        knowledgeID: this.MultXList[index].knowledgeID,
        order: this.MultXList[index].order,
        qid: this.MultXList[index].qID,
        qtype: this.MultXList[index].qtype,
        score: this.MultXList[index].score
      };
      // console.log("str", str);
      this.uploadAnswerSafely([str]);
    },
    multiIndexChange(index) {
      // console.log(this.MultXList1);
      this.subjectIndex = index;
      //arr是乱序序号数组
      let arr = this.MultXList1[this.subjectIndex].options;
      this.MultXList1[this.subjectIndex].options = [];
      let arrq = this.MultXList1[this.subjectIndex].steam;
      this.MultXList1[this.subjectIndex].steam = [];
      // this.randomSortArray(arr);
      this.$nextTick(() => {
        this.MultXList1[this.subjectIndex].options = arr;
        this.MultXList1[this.subjectIndex].steam = arrq;
      });
      this.multipleTemp = this.MultXList[this.subjectIndex].answers;
      // console.log(this.multipleTemp);
    },
    async submitFunc() {
      if (this.isSubmitting || this.submitLoading) {
        return;
      }
      this.isSubmitDisabled = true;
      if (this.enableSubmit) {
        try {
          await this.$confirm("开考时间不足30分钟,是否继续交卷？", "提示", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning"
          });
        } catch (error) {
          this.isSubmitDisabled = false;
          return;
        }
      }
      this.SingXList = this.SingXList.map(item => {
        if (item.answers) {
          let temp = "";
          item.answerIndex.forEach(item1 => {
            if (item1.name === item.answers) {
              temp = item1.value;
            }
          });
          item.answer = temp;
        } else {
          item.answer = "";
        }
        return item;
      });
      this.MultXList = this.MultXList.map(item => {
        if (item.answers) {
          let temp = _.cloneDeep(item.answers);
          for (var i in item.answers) {
            for (var j in item.answerIndex) {
              if (item.answers[i] === item.answerIndex[j].name) {
                temp[i] = item.answerIndex[j].value;
              }
            }
          }
          item.answer = temp.join(",");
        } else {
          item.answer = "";
        }
        return item;
      });
      // console.log("submit", this.MultXList);
      this.JudgXList = this.JudgXList.map(item => {
        // item.answer = ""
        item.answer = item.answers;
        return item;
      });
      let overSing = this.SingXList.some(val => val.answer === "");
      let overMult = this.MultXList.some(val => val.answer === "");

      let overfill = this.JudgXList.some(val => val.answer === "");
      console.log(overSing, overMult, overfill);
      if (overSing === false && overMult === false && overfill === false) {
        this.$confirm(
          "如提交试卷，将无法再次进入该试卷，试卷成绩将提交",
          "提示",
          {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            this.submit();
          })
          .catch(() => {
            this.isSubmitDisabled = false;
          });
      } else {
        this.unfinished = [];
        this.SingXList.map((item, index) => {
          if (item.answer === "") {
            this.unfinished.push("单选题" + (index + 1));
          }
        });
        this.MultXList.map((item, index) => {
          if (item.answer === "") {
            this.unfinished.push("多选题" + (index + 1));
          }
        });
        this.JudgXList.map((item, index) => {
          if (item.answer === "") {
            this.unfinished.push("判断题" + (index + 1));
          }
        });
        this.$alert(this.unfinished, "未选择答案", {
          confirmButtonText: "确认"
        });
        console.log(this.unfinished);
        this.isSubmitDisabled = false;
        this.$message.error("答题未完成，还有题目未答");
        this.submitLoading = false;
      }
    },
    submitFuncV2() {
      if (this.isSubmitting || this.submitLoading) {
        return;
      }
      this.SingXList = this.SingXList.map(item => {
        if (item.answers) {
          let temp = "";
          item.answerIndex.forEach(item1 => {
            if (item1.name === item.answers) {
              temp = item1.value;
            }
          });
          item.answer = temp;
        } else {
          item.answer = "";
        }
        return item;
      });
      this.MultXList = this.MultXList.map(item => {
        if (item.answers) {
          let temp = _.cloneDeep(item.answers);
          for (var i in item.answers) {
            for (var j in item.answerIndex) {
              if (item.answers[i] === item.answerIndex[j].name) {
                temp[i] = item.answerIndex[j].value;
              }
            }
          }
          item.answer = temp.join(",");
        } else {
          item.answer = "";
        }
        return item;
      });
      this.JudgXList = this.JudgXList.map(item => {
        item.answer = item.answers;
        return item;
      });
      this.submit();
    },
    //乱序排序
    randomSortArray(arr) {
      // console.log(arr);
      var len = arr.length;
      for (var i = len - 1; i >= 0; i--) {
        var randomIndex = Math.floor(Math.random() * (i + 1));
        var temp = arr[randomIndex];
        arr[randomIndex] = arr[i];
        arr[i] = temp;
      }
      // console.log(arr);
      return arr;
    },
    //检查交卷
    checkoutSubmit() {
      if (
        this.countdownTime < 0 &&
        !this.isSubmitting &&
        !this.submitLoading
      ) {
        this.submitFuncV2();
      }
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-menu-item-group > ul {
  display: flex;
  // justify-content: space-between;
  flex-wrap: wrap;
  padding: 0px !important;
}
::v-deep .el-menu-item {
  padding: 0px !important;
}
::v-deep .el-menu-item > span {
  display: inline-block;
  width: 48px;
  height: 48px;
}
::v-deep .el-menu-item.is-active {
  background-color: #409eff !important;
  color: #fff !important;
}
::v-deep .el-menu-item.is-active span {
  // background-color: #409eff !important;
  color: #fff !important;
}
.page {
  display: flex;
  font-size: 14px;
  width: 100%;
  overflow-y: vertical;
  height: 100%;
  box-sizing: border-box;
  background-color: rgb(248, 250, 251);
  .btnBox1 {
    position: fixed;
    bottom: 0px;
  }

  .left {
    position: relative;
    width: 15%;
    height: 100%;

    .el-menu-vertical-demo {
      width: 100%;
      overflow-y: vertical;
    }

    .btnBox {
      position: absolute;
      left: 0;
      bottom: 0;
      height: 40px;
      width: 100%;
      display: flex;
      justify-content: space-around;
      @media screen and (max-width: 1024px) {
        position: absolute;
        left: 0;
        bottom: 0;
      }
      @media screen and (max-width: 768px) {
        position: absolute;
        left: 0;
        bottom: 0;
      }
    }
    .item {
      display: flex;
      padding: 20px 30px;
      // background: #f8fafb;
      cursor: pointer;
      img {
        width: 20px;
        margin-right: 15px;
        height: 20px;
      }
    }
  }
  .center {
    background: #f8fafb;
    width: 223px;
    height: 100%;
    // width: 100px;
    overflow: auto;
    .wrap {
      width: 80%;
      display: flex;
      padding: 10px 0;
      flex-wrap: wrap;
      //justify-content: space-around;
      align-items: center;
      cursor: pointer;
      //  white-space:normal;
      //    word-break:break-all;
      //    word-wrap:break-word;
    }
    .item {
      white-space: wrap;
      margin: 0 15px;
      white-space: normal;
      word-break: break-all;
      word-wrap: break-word;
    }
    .blue {
      color: #006dfe;
    }
  }
  .right {
    box-sizing: border-box;
    flex-grow: 1;
    padding: 28px;
    background: #f8fafb;
    text-align: left;
    // width: 3300px;
    width: 85%;
    position: relative;
    height: 90vh;
    overflow-y: scroll;

    .item {
      font-size: 14px;
      background: #fff;
      justify-content: left;
      padding: 26px 20px;
      // margin-top: 15px;
      width: 90%;
      .title {
        font-size: 20px;
        margin-bottom: 20px;
        overflow-x: hidden;
        div {
          overflow-x: auto;
        }
      }
      .el-checkbox-group {
        width: 100%;
        .multx {
          width: 100%;
        }
      }
      img {
        // 有图片的题目保持和文字居中对齐
        vertical-align: middle;
      }
    }
    .bottom {
      // position: fixed;
      // bottom: 100px;

      padding: 0px 20px;
      margin: 0 auto;
      // background: #fff;
      height: 40px;
      display: flex;
      line-height: 40px;
      justify-content: center;
      margin-top: 50px;
      .last,
      .next {
        margin: 0 100px;
        cursor: pointer;
      }
    }
  }
  // .multx {
  //   width: 100%;
  //   white-space: nowarp;
  //   overflow-x: auto;
  //   margin-left: 20px;
  // }
  .el_radio_group {
    width: 1000px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;

    font-size: 20px;
    white-space: normal;
    word-break: break-all;
    word-wrap: break-word;
    .el_radio {
      width: 100%;
      padding: 15px;
      // border-bottom: solid 1px #eee;
      display: flex;
      align-items: center;
    }
  }
}

.info {
  position: relative;
  height: 100%;
  overflow-y: visible;
  .time {
    position: absolute;
    top: -55px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    // border-bottom: 2px solid #f8fafb;
    flex-grow: 1;
    flex-direction: row-reverse;
    align-items: center;
    display: flex;
    width: 70%;
    @media screen and (max-width: 1024px) {
      width: 100%;
    }
    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
  .examinationInfo {
    display: flex;
    .cell {
      display: flex;
      align-items: center;
      margin: 0 10px;
      .name {
        white-space: nowrap;
        margin: 0 10px;
      }
    }
  }
}
// 多选的框隐藏
::v-deep .el-checkbox__inner {
  display: none;
}
.box {
  font-size: 40px;
}
.box1 {
  font-size: 40px;
}
.active {
  background-color: #f8fafb;
  color: blue;
}
::v-deep .el_radio_group .el-radio__label {
  font-size: 20px;
}
::v-deep .el-radio__label {
  font-size: 20px;
}
::v-deep .el_radio_group .el-checkbox__label {
  font-size: 18px;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}

::v-deep .el-checkbox .el-checkbox__input {
  width: 40px;
  height: 40px;
  // border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
}
::v-deep .el-checkbox__input {
  width: 40px;
  height: 40px;
  // border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
}
::v-deep .el-radio__inner {
  border: 0;
  width: 0;
  height: 0;
}
::v-deep .groupbox .el-radio .el-radio__input:hover {
  border-color: #409eff;
}
::v-deep .groupbox .el-radio .el-radio__input {
  width: 40px;
  height: 40px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
}
// ::v-deep .el-checkbox .el_radio {
//   padding-left: 20px;
// }
::v-deep .el-checkbox .el-checkbox__input {
  width: 40px;
  height: 40px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
}
.labelbox {
  margin-left: -40px;
  // line-height: 40px;
  vertical-align: middle;
}
::v-deep .el-checkbox__label {
  width: 80%;
  padding-top: 5px;
  font-size: 22px !important;
}
::v-deep .el-checkbox .el_radio {
  vertical-align: top;
  font-size: 22px !important;
}
::v-deep .el-icon-circle-close:hover {
  color: #409eff;
}
::v-deep .el-icon-circle-check:hover {
  color: #409eff;
}
::v-deep .katex {
  font-size: 24px;
}
::v-deep .color {
  color: rgb(64, 158, 255);
}
::v-deep .el-submenu .el-menu-item {
  width: 50px !important;
  min-width: 50px !important;
  margin-bottom: 10px;
  overflow: hidden;
  background: #eee;
  border-radius: 50px;
}
.multx {
  font-size: 20px !important;
  margin-top: 10px;
}
::v-deep .wrap {
  word-wrap: break-word;
}
::v-deep .scroll {
  min-height: 300px;
  overflow-y: auto;
}
.active1 {
  width: 100px !important;
}
.margin {
  font-size: 20px;
  margin-bottom: 20px;
  font-size: 22px;
  font-weight: bold;
}
.title1 {
  margin: 20px 0px;
}
.subTitle {
  font-size: 19px;
  // font-weight: bold;
  word-wrap: break-word;
  .el-checkbox {
    .el-checkbox__label {
      font-size: 22px !important;
      width: 80%;
    }
  }
}
</style>
